import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getAllTradingPlatforms = async () => {
  const { data, error } = await supabase
    .from('trading_platforms')
    .select('*')
    .eq('active', true)

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetAllTradingPlatforms() {
  return useQuery({
    queryKey: ['useGetAllTradingPlatforms'],
    queryFn: () => getAllTradingPlatforms(),
    staleTime: 0,
    cacheTime: 0,
  })
}
